import { DRAG_START, DRAG_END } from '../../../../actions/board/drag/index.tsx';
import type { Action } from '../../../../types.tsx';

export const isPollingEnabledReducer = (state = true, action: Action): boolean => {
	if (action.type === DRAG_START) {
		return false;
	}

	if (action.type === DRAG_END) {
		return true;
	}

	return state;
};
